<template>
    <div class="container">
        <div class="head_card">
            <!-- <img src="@/assets/profile/home_person_topbg.png" alt=""> -->
            <van-row>
                <van-col span="6" class="avatar">
                    <img src="@/assets/common/head_icon.jpg" alt="">
                </van-col>
                <van-col span="14">
                    <div class="id">{{ $t('profile.id') }} : {{ id }}
                        <img src="@/assets/common/copy_icon.png" alt="" @click="onCopyID(id)">
                    </div>
                    <div class="contact">{{ $t('profile.account') }} : {{ name }} </div>
                    <div class="value"><span>{{ formatCurrency(balance) }}</span> R$</div>
                </van-col>
                <van-col span="4" class="mail">
                    <van-badge v-if="unreadMsgCount > 0" :content="unreadMsgCount">
                        <img src="@/assets/profile/home_email.png" alt="" @click="onClickCard"
                        :class="{ 'pop-animate': isPopping }">
                    </van-badge>
                    <img v-else src="@/assets/profile/home_email.png" alt="" @click="onClickCard"
                        :class="{ 'pop-animate': isPopping }">
                </van-col>
                <van-col span="12" class="withdraw_btn">
                    <PrimaryButton :icon="require('@/assets/sideNavbar/home_withdrawal.png')" :text="$t('common.sake')"
                        textColor="#FFFFFF" bgColor="#3d2e22" @onClick="onButtonClick('withdraw')" />
                </van-col>
                <van-col span="12" class="deposit_btn">
                    <PrimaryButton :icon="require('@/assets/sideNavbar/home_recharge.png')"
                        :text="$t('common.deposite')" textColor="#000"
                        bgColor="linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%)" @onClick="onButtonClick('topup')" />
                </van-col>
            </van-row>
        </div>

    <StatusPopup ref="statusRef" :content="$t('common.copied')" :isShowSuccess="true" />
    </div>
</template>

<script setup lang="ts">
import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { formatCurrency } from '@/utils/commonFunction';
import { buttonClick, clickOnCard, copyID } from '@/view/profile/supportScript';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import PrimaryButton from '../../components/common/primaryButton.vue';

const router = useRouter()
const statusRef = ref();
const userStore = useUserStore()
const name = computed(() => userStore.nickname)
const balance = computed(() => userStore.balance)
const id = computed(() => userStore.id)
const unreadMsgCount = computed(() => userStore.unreadCount)
const isPopping = ref(false)

const onClickCard = () => clickOnCard(router, isPopping, '/sd-message')
const onCopyID = (id : any) => copyID(statusRef, id)
const onButtonClick = (type: string) => buttonClick(router, type)

</script>
<style scoped>
.container {
    padding: 5px 0;
}

.head_card img {
    width: 100%;
}

.avatar img {
    width: 80px;
    border-radius: 20px;
}

@media (max-width:450px) {
    .content {
        margin: -39vw 0 1vh 0;
        padding: 0 15px;
    }
}

@media (min-width: 500px) {
    .content {
        margin: -22vh 0 6vh 0;
        padding: 0 15px;
        font-size: 2.1vh;
    }
    .head_card {
        /* padding: 1vw; */
        padding-bottom: 0;
    }
    .button_container {
        font-size: 2.1vh;
    }
}

@media (min-width: 1440px) {
    .content {
        margin: -11vw 0 3vh 0;
        padding: 0 15px;
        font-size: 1vw;
    }
    .button_container {
        font-size: 1vw;
    }
}

@media (min-width: 1920px) {
    .content {
        margin: -9vw 0 6vh 0;
        padding: 0 15px;
        font-size: 1vw;
    }
    .head_card {
        /* padding: 1vw; */
        padding-bottom: 0;
    }
    .button_container {
        font-size: 1vw;
    }
}

.mail {
    display: flex;
    justify-content: right;
}

.mail img {
    width: 30px;
    height: 32px;
}

.id {
    color: #fff;
    padding: 5px;
    display: flex;
    align-items: center;
    flex-direction: row;
}

.id img {
    width: 15px;
    padding: 0 5px;
}

.contact {
    color: #fff;
    padding: 5px;
}

.value {
    color: rgba(255, 255, 255, 0.65);
    padding: 5px;
    font-size: 18px;

}

.value span {
    color: #fff;
    font-weight: bold;
}

.withdraw_btn {
    padding: 5px;
}

.deposit_btn {
    padding: 5px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.75);
    }

    100% {
        transform: scale(1);
    }
}

.container {
    background: linear-gradient(to bottom, #693d05f0, #00000061);
    margin: 20px 15px;
    border-radius: 25px;
    border-top: 3px solid orange;
    border-bottom: 3px solid orange;
    padding: 10px;
}
</style>